module.exports = __webpack_public_path__ + "img/ico_info-white.9fe9e70f.svg";